// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/54f48fdfd078babfb2a0.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"112e68d8c678507444d6","121":"b39e49c12eb42fc8ef64","122":"058af923edbb57c9ad23"}[chunkId] + ".chunk.js";
};